import { useParams } from "react-router";

import { CampaignOrgUnitsEditForm } from "src/app/features/Campaign/components/forms/CampaignOrgUnitsEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { GenerateCampaignButton } from "../../../../components/FeatureButtons/GenerateCampaignButton";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const CampaignOrgUnitsEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk, triggerGenerate } = useFormSubmitTrigger();
    const hasWriteAccess = canAccess(ResourceName.CAMPAIGNS, "basicTabsWrite");
    const { id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CAMPAIGNS}/${id}/${FORM_ACTION.HISTORY}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.campaignsEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={!hasWriteAccess} onClick={triggerOk} />
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerSubmit} />
                    <GenerateCampaignButton isDisabled={!hasWriteAccess} onClick={triggerGenerate} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.CAMPAIGNS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CampaignOrgUnitsEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
